/* eslint-disable no-useless-computed-key */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef, useCallback } from 'react';
import customStyles from "../../../../../assets/styles/customStyles";
import MainHeader from "../../../../Shared/components/Header";
import SalesIcon from "../../../../../assets/images/icon_menus/SalesIcon.json";
import clsx from "clsx";
import { useDispatch, useSelector } from "react-redux";
import { Button, TextField, Box, Switch, FormControlLabel, FormControl, FormLabel, RadioGroup, Radio, InputAdornment, IconButton, Tooltip } from "@mui/material";
import { Col, Image, Row } from "antd";
import { SelectedIcon, UnSelectedIcon } from "../../../../Shared/components/Icons/selectedIcon";
import SearchIcon from "../../../../../assets/images/icon_actions/Search Icon.svg";
import Typography from '@mui/material/Typography';
import Search from "../../../../Shared/components/Icons/Search";
import { PrimaryDrawer } from "../../../../Shared/components/Drawer/PrimaryDrawer";
import crudActions from "../../../../CRUD/redux/actions";
import addressActions from "../../../../Admin/Address/redux/actions";
import globalAddressActions from "../../../../Admin/Home/redux/actions";
import groupActions from "../../../Setup/redux/actions";
import gstActions from "../../../../Admin/Setup/redux/actions";
import usePrevious from "../../../../Shared/components/Previous";
import { customerTypeList, classificationList } from "../../../../../config/constant";
// import businessActions from "../../../../Admin/Home/redux/actions";
import actions from "../../redux/actions";
import {
    emptyValidation, customAlaphaNumericValidation,
    customAlaphaNumericValidationOptional, customEmailOptionalValidation
} from "../../../../../helpers/validation";
import { toast } from 'react-toastify';
import { CustomAccordion } from "../../../../Shared/components/AccordionComponent";
import { QuickLinks } from "../../../../Shared/components/BreadCrumbNew/QuickLinks";
import qucikLinksActions from "../../../../Dashboard/redux/actions";
import { AutoCompleteComponent } from "../../../../Shared/components/AutoCompleteComponent";
import PrimaryCard from "../../../../Shared/components/Card/PrimaryCard";
import { AddressTable } from "../../../../Shared/components/AddressTable";
import { checkCRUDViewPermission, checkCRUDPermission, capitalizeFirstLetter, scrollToError, getBusinessId, idNamingConversion } from "../../../../../helpers/utilities";
import CustomAlert from "../../../../Shared/components/CustomAlert";
import { AESEncrypt } from "../../../../../helpers/Crypto";
import younoteAdminSetupActions from "../../../../YounoteAdmin/Setup/redux/actions";
import { useEventListener } from "../../../../../helpers/useEventListener"
import infoMarkIcon from "../../../../../assets/images/icon_actions/infoMark.svg";


const CustomerCreate = (props) => {
    const [visible, setVisible] = useState(false);
    const { areaDetails, languageDetails, pincodeDetails, stateDetails, countryDetails, cityDetails } = useSelector(state => state.addressReducer);
    const { partyGstdetails, currencyDetails, mopDetails, taxCodedetails, cashDiscountDetails, otherTaxesdetails } = useSelector(state => state.adminSetupReducer);
    const { customerGroupdetails } = useSelector(state => state.salesSetupReducer);
    const { createDetails, createError, createLoader, createData } = useSelector(state => state.crudReducer);
    const { addressDetails, addressLoader, getTeamData, businessDetails } = useSelector(state => state.homeReducer);
    const dispatch = useDispatch();
    const { history } = props;
    const prevCreateDetails = usePrevious(createDetails);
    const prevCreateError = usePrevious(createError);
    const { roleManagement } = useSelector(state => state.authReducer);
    const { taxType } = useSelector(state => state.younoteAdminSetupReducer);
    const [addressSearchAll, setAddressSearchAll] = useState('');
    const prevAddressSearchAll = usePrevious(addressSearchAll);
    const timeoutRef = useRef('');

    const [iconAnimation, setIconAnimation] = useState(false);
    const [businessType, setBusinessType] = useState('');
    const [name, setName] = useState('');
    const [gabId, setGabId] = useState('');
    const [isHold, setIsHold] = useState(false);
    const [mobile, setMobile] = useState('');
    const [email, setEmail] = useState('');
    const [classification, setClassification] = useState('');
    const [languageId, setLanguageId] = useState(1);
    const [groupId, setGroupId] = useState('');
    const [salesRepId, setSalesRepId] = useState('');
    const [gstCodeId, setGstCodeId] = useState('');

    const [gstin, setGstin] = useState('');
    const [address1, setAddress1] = useState('');
    const [areaId, setAreaId] = useState('');
    const [pincodeId, setPincodeId] = useState('');
    const [priceIncludesTax, setPriceIncludesTax] = useState(false);
    const [stateId, setStateId] = useState('');
    const [cityId, setCityId] = useState('');
    const [identityType, setIdentityType] = useState('');
    const [pan, setPan] = useState('');
    const [countryId, setCountryId] = useState('');
    const sortOrder = "asc";
    const sortBy = "contactName";

    const [contactName, setContactName] = useState('');
    const [tradingName, setTradingName] = useState('');
    const [alternateMobile, setAlternateMobile] = useState('');
    const [mopId, setMopId] = useState('');
    const [taxCodeId, setTaxCodeId] = useState('');
    const [cashDiscountId, setCashDiscountId] = useState('');
    const [tcs, setTcs] = useState(false);
    const [tcsId, setTcsId] = useState('');
    const [tdsId] = useState('');
    const [tds, setTds] = useState(false);
    const [currencyId, setCurrencyId] = useState('');
    const [younoteID, setYounoteID] = useState('');
    const [younoteSerial, setYounoteSerial] = useState('');
    const [inAppStatus, setInAppStatus] = useState('');
    const [errorBusinessType, setErroBusinessType] = useState(false);
    const [errorName, setErrorName] = useState(false);
    const [errorTcs, setErrorTcs] = useState(false);
    const [commonError, setCommonError] = useState(false);
    const [errorMobile, setErrorMobile] = useState(false);
    const [errorGstIn, setErrorGstIn] = useState(false);
    const [errorPincode, setErrorPincode] = useState(false);
    const [errorState, setErrorState] = useState(false);
    const [errorEmail, setErrorEmail] = useState(false);
    const [errorGstType, setErrorGstType] = useState(false);
    const [errorGstCode, setErrorGstCode] = useState(false);
    const [errorLanguage, setErrorLanguage] = useState(false);
    const [errorCurrency, setErrorCurrency] = useState(false);
    const [errorClassification, setErrorClassification] = useState(false);
    const [errorContactForm, setErrorContactForm] = useState(false);
    const [erroremptyAlternateName, setErroremptyAlternateName] = useState(false);
    //const [erroremptyAlternateNumber, setErroremptyAlternateNumber] = useState(false);
    const [gstTypeList, setGstTypeList] = useState([]);
    const [taxTypeId, setTaxTypeId] = useState('');
    const childRef = useRef('');

    const handleChangeCountry = (value) => {
        setCountryId(value);
        setStateId('');
        setCityId('');
        setPincodeId('');
        setAreaId('');
        let a = countryDetails.filter(function (el) { return el.id === value });
        if (a && a?.length !== 0) {
            setCurrencyId(a[0].currencyId);
        }
        dispatch({
            type: younoteAdminSetupActions.TAX_TYPE_START,
            url: `/tax-types/byCountry/${value}`,
            // filter: {
            //     where: { countryTaxId: 1 }
            // }
        });
    }

    const factBox = [];
    const menus = [
        {
            "name": "Create Order",
            "link": "",
            'disabled': true
        },
        {
            "name": "Create Sales Bill",
            "link": `/sales/sales-management/self-bill/create`,
            'disabled': true
        },
        {
            "name": "Collect Payment",
            "link": "",
            'disabled': true
        },
        {
            "name": "Invoice History",
            "link": "",
            'disabled': true
        },
        {
            "name": "Order History",
            "link": "",
            'disabled': true
        },
        {
            "name": "Settlement",
            "link": "/sales/report-and-enquiry/customer-settlement",
            'disabled': true
        },
        {
            "name": "Transaction History",
            "link": "/sales/transactions/customer-transaction",
            'disabled': true
        }
    ];

    const handleClose = () => {
        setVisible(false);
    };

    const handleOpen = () => {
        setVisible(true);
    };

    const emptyState = () => {
        setErroBusinessType(false);
        setErrorName(false);
        setCommonError(false);
        setErrorMobile(false);
        setErrorEmail(false);
        setErrorGstType(false);
        setErrorLanguage(false);
        setErrorCurrency(false);
        setErrorGstCode(false);
        setErrorClassification(false);
        setErrorContactForm(false);
        setErroremptyAlternateName(false);
        // setErroremptyAlternateNumber(false);
        setErrorGstIn(false);
        setErrorPincode(false);
        setErrorState(false);
        setErrorTcs(false);
    }

    useEffect(() => {
        if (roleManagement !== '' && checkCRUDViewPermission('All Customers', 'create', history, 'Sales')) {
            loadTasks();
        }
        return () => {
            dispatch({ type: addressActions.CLEAR_ADDRESS_DETAILS_START });
            dispatch({ type: younoteAdminSetupActions.CLEAR_SETUP_START });
            dispatch({ type: actions.CLEAR_MANAGEMENT_DETAILS_START });
        }

    }, [roleManagement]);

    const handleKeyDown = (e) => {
        if (e.altKey && e.keyCode === 83) {
            e.preventDefault();
            handleSubmit(e);
        }
    };

    useEventListener("keydown", handleKeyDown);

    useEffect(() => {
        if (businessDetails && businessDetails !== '' && stateDetails && stateDetails?.length > 0) {
            if (businessDetails?.stateId) {
                changeState(businessDetails?.stateId);
                setPriceIncludesTax(businessDetails?.priceIncludesTax || false);
            }
        }
    }, [businessDetails, stateDetails]);

    useEffect(() => {
        if (countryId !== '') {
            setGstTypeList(taxType);
            if (taxTypeId === '' && taxType && taxType?.length > 0) {
                let a = taxType && taxType?.filter((el) => el.isDefault);
                if (a && a.length > 0) {
                    setTaxTypeId(a[0]?.id);
                    if (a[0]?.partyGstId) {
                        setGstCodeId(a[0]?.partyGstId || '');
                    }
                }
            }
        }
    }, [countryId, taxType]);

    const loadTasks = useCallback(() => {
        setTimeout(function () {
            dispatch({ type: qucikLinksActions.QUICKLINKS_START, menus: menus, toggle: true, factBox: factBox, component: "All Customers" });
        }, 200);
        dispatch({
            type: addressActions.STATE_DETAILS_START, url: 'state', filter: {
                order: 'id  desc'
            }
        });
        dispatch({
            type: globalAddressActions.TEAM_DETAILS_START, url: 'team', filter: {
                order: 'id  desc'
            }
        });
        dispatch({
            type: addressActions.COUNTRY_DETAILS_START, url: 'country', filter: {
                order: 'id  desc'
            }
        });
        dispatch({
            type: groupActions.CUSTOMERGROUP_DETAILS_START, url: 'customer-group', filter: {
                order: 'id  desc'
            }
        });
        dispatch({
            type: gstActions.TAXCODE_DETAILS_START, url: 'taxcode', filter: {
                order: 'id desc'
            }
        });
        dispatch({
            type: gstActions.CASHDISCOUNT_DETAILS_START, url: 'cashdiscount', filter: {
                order: 'id desc'
            }
        });
        dispatch({
            type: gstActions.OTHERTAXES_DETAILS_START, url: 'othertaxes', filter: {
                order: 'id desc'
            }
        });
        dispatch({
            type: gstActions.PARTYGST_DETAILS_START, url: 'partygst', filter: {
                order: 'id  desc'
            }
        });
        dispatch({
            type: addressActions.LANGUAGE_DETAILS_START, filter: {
                order: 'id  desc'
            }
        });
        dispatch({
            type: gstActions.CURRENCY_DETAILS_START, url: 'currency', filter: {
                order: 'id  desc'
            }
        });
        dispatch({
            type: gstActions.MOP_DETAILS_START, url: 'mop', filter: {
                order: 'id  desc'
            }
        });
    });

    const handleSubmit = (e) => {
        e.preventDefault();
        childRef?.current?.handleAdjustHeight();
        let emptyGstIn = {};
        let emptyBusinessType = emptyValidation('Business Type', businessType, 'dropDown');

        let emptyName = emptyValidation('Name', name);
        let emptyMobile = emptyValidation('Mobile Number', mobile);
        let emptyEmail = customEmailOptionalValidation('Email', email);

        let emptyTaxTypeId = emptyValidation('Gst Type', taxTypeId, 'dropDown');
        let emptyLanguage = emptyValidation('Language', languageId, 'dropDown');
        let emptyCurrency = emptyValidation('Currency', currencyId, 'dropDown');
        //let emptyContactName = customAlaphabetValidationOptional('Contact Name', contactName)
        //let emptyAlternateName = customAlaphabetValidationOptional('Alternate Name', tradingName)
        // let emptyClassification = emptyValidation('Classification', classification);
        //let emptyalternateMobile = customPhoneValidationOptional('Alternate Phone', alternateMobile);
        let emptyPincode = emptyValidation('Pincode', pincodeId, 'dropDown');
        let emptyStateVal = emptyValidation('State', stateId, 'dropDown');


        let emptyGstCode = { isValid: true };
        if (taxTypeId !== '') {
            let a = taxType && taxType?.filter((el) => el.id === taxTypeId);
            if (a && a.length > 0 && (a[0].taxCode === 'UNRB' || a[0].taxCode === 'COMP' || a[0].taxCode === 'CONS')) {
                emptyGstIn = customAlaphaNumericValidationOptional('GST IN', gstin, 15);
            } else {
                emptyGstIn = customAlaphaNumericValidation('GST IN', gstin, 15);
            }

            if (a && a.length > 0) {
                if (a[0].taxCode === 'UNRB' || a[0].taxCode === 'COMP' || a[0].taxCode === 'CONS') {
                    emptyGstCode = { isValid: true };
                } else {
                    emptyGstCode = emptyValidation('Gst Code', gstCodeId, 'dropDown');
                }
            }
        }

        let emptyTcs = { isValid: true };

        if (tcs) {
            emptyTcs = emptyValidation('TCS', tcsId, 'dropDown');
        }

        emptyState();
        if (emptyBusinessType.isValid && emptyName.isValid && emptyEmail.isValid && emptyMobile.isValid && emptyTaxTypeId.isValid
            && emptyLanguage.isValid && emptyCurrency.isValid && emptyGstCode.isValid
            && emptyGstIn.isValid && emptyPincode.isValid && emptyStateVal.isValid && emptyTcs.isValid
        ) {
            let details = {
                type: businessType,
                name: name,
                email: email || '',
                mobile: mobile,
                isHold: isHold,
                //classification: classification,
                languageId: languageId,
                taxTypeId: taxTypeId,
                gstin: gstin,
                address1: address1 ? address1 : '',
                contactName: contactName,
                tradingName: tradingName,
                alternateMobile: alternateMobile,
                currencyId: currencyId,
                pincodeId: pincodeId,
                countryId: countryId,
                businessId: getBusinessId(),
                priceIncludesTax: priceIncludesTax || false,
                taxCodeId: taxCodeId || 0,
                tcsId: tcsId || 0,
                tdsId: tdsId || 0,
                tcsBoolean: tcs || false,
                tdsBoolean: tds || false,
                cashDiscountId: cashDiscountId || 0
            };

            if (pan) {
                let ideType = identityType || 'PAN';
                details["pan"] = ideType + '-' + pan;
            } else {
                details["pan"] = '';
            }

            if (classification) {
                details["classification"] = classification;
            }

            if (gabId) {
                details["gabId"] = gabId;
            }
            if (groupId) {
                details["groupId"] = groupId;
            }
            if (groupId) {
                details["groupId"] = groupId;
            }
            if (salesRepId) {
                details["salesRepId"] = salesRepId;
            }
            if (mopId) {
                details["mopId"] = mopId;
            }
            if (areaId) {
                details["areaId"] = areaId;
            }
            if (stateId) {
                details["stateId"] = stateId;
            }
            if (cityId) {
                details["cityId"] = cityId;
            }

            if (younoteID) {
                details["inAppStatus"] = 'REQUEST SENT';
                details["inAppTransition"] = true;
                details["customerBusinessId"] = younoteID;
            } else {
                details["inAppStatus"] = 'NO';
                details["inAppTransition"] = false;
            }

            dispatch({
                type: crudActions.CREATE_DETAILS_START,
                url: "customerProfile",
                title: "Customer Profile",
                details: details
            })
        } else {
            // if (emptyClassification.errors) {
            //     setErrorClassification(emptyClassification.errors);
            // }
            if (emptyBusinessType.errors) {
                setErroBusinessType(emptyBusinessType.errors);
            }
            if (emptyName.errors) {
                setErrorName(emptyName.errors);
            }
            if (emptyTcs.errors) {
                setErrorTcs(emptyTcs.errors);
            }
            if (emptyMobile.errors) {
                setErrorMobile(emptyMobile.errors);
            }
            if (emptyEmail.errors) {
                setErrorEmail(emptyEmail.errors);
            }

            if (emptyTaxTypeId.errors) {
                setErrorGstType(emptyTaxTypeId.errors);
            }

            // if (taxTypeId !== '') {
            //     let a = taxType && taxType?.filter((el) => el.id === taxTypeId);
            //     if (a && a.length > 0 && a[0].taxCode !== 'UNRB' && emptyGstCode.errors) {
            //         setErrorGstCode(emptyGstCode.errors);
            //     }
            // }

            if (emptyGstCode.errors) {
                setErrorGstCode(emptyGstCode.errors);
            }

            if (emptyPincode.errors) {
                setErrorPincode(emptyPincode.errors);
            }
            if (emptyStateVal.errors) {
                setErrorState(emptyStateVal.errors);
            }
            if (emptyLanguage.errors) {
                setErrorLanguage(emptyLanguage.errors);
            }
            if (emptyCurrency.errors) {
                setErrorCurrency(emptyCurrency.errors);
            }
            // if (emptyContactName.errors) {
            //     setErrorContactForm(emptyContactName.errors);
            // }
            // if (emptyAlternateName.errors) {
            //     setErroremptyAlternateName(emptyAlternateName.errors);
            // }
            // if (emptyalternateMobile.errors) {
            //     setErroremptyAlternateNumber(emptyalternateMobile.errors);
            // }
            if (emptyGstIn.errors) {
                setErrorGstIn(emptyGstIn.errors);
            }
            scrollToError();
        }
    }

    useEffect(() => {
        if (prevCreateDetails !== undefined && createDetails && prevCreateDetails !== createDetails) {
            toast.dismiss();
            //toast(createDetails);
            if (roleManagement !== '' && checkCRUDPermission('All Customers', 'view', 'Sales')) {
                history.push(`/sales/sales-management/all-customers/${AESEncrypt(createData.id)}/view`, 'create');
            } else {
                history.push(`/sales/sales-management/all-customers`);
            }
        } else if (prevCreateError !== undefined && createError && prevCreateError !== createError) {
            let error = createError.error.message;
            toast.dismiss();
            toast.error(error);
            // let error = message.split("|");
            // if (error[0].trim() === 'name') {
            //     setErrorName(error[1]);
            // } else {
            //     setCommonError(message);
            // }
        }
    }, [createDetails, createError]);

    const changeArea = (value) => {
        setAreaId(value);
    }

    const changePincode = (value) => {
        setPincodeId(value);
        setAreaId('');
        let a = pincodeDetails && pincodeDetails.filter(function (el) { return el.id === value });
        if (a && a?.length !== 0) {
            setCityId(a[0].cityId);
            dispatch({
                type: addressActions.AREA_DETAILS_START, url: 'areas', filter: {
                    where: { ["and"]: [{ pincodeId: value }] }
                }
            });
        }
        return [];
    }

    const changeCity = (value) => {
        setCityId(value);
        setAreaId('');
        setPincodeId('');
    }

    const changeState = (value) => {
        setStateId(value);
        setCityId('');
        setPincodeId('');
        setAreaId('');
        let a = stateDetails && stateDetails.filter(function (el) { return el.id === value });
        if (a && a?.length !== 0) {
            setCountryId(a[0].countryId);
            setCurrencyId(a[0].country ? a[0].country.currencyId : '');
            dispatch({
                type: younoteAdminSetupActions.TAX_TYPE_START,
                url: `/tax-types/byCountry/${a[0].countryId}`,
                // filter: {
                //     where: { countryTaxId: 1 }
                // }
            });
        }
        changeStateApi(value);
    }

    const changeStateApi = (value) => {
        dispatch({
            type: addressActions.PINCODE_DETAILS_START, url: 'pincode', filter: {
                where: { ["and"]: [{ stateId: value }] }
            }
        });
        dispatch({
            type: addressActions.CITY_DETAILS_START, url: 'city', filter: {
                where: { ["and"]: [{ stateId: value }] }
            }
        });
    }

    const addressSearch = () => {
        let filter = { ["and"]: [{ isGloballyVisible: true }] };
        let or = { ["or"]: [] }

        if (name !== '' && name !== null && name.length > 6) {
            or['or'].push({ businessName: { like: name.trim() + '%' } });
            or['or'].push({ contactName: { like: name.trim() + '%' } });
            or['or'].push({ email: { like: name.trim() + '%' } });
        }
        if (mobile !== '' && mobile !== null && mobile.length >= 10) {
            filter['and'].push({ mobile: { like: mobile.trim() + '%' } });
        }

        if (or.or.length > 0) {
            filter['and'].push(or);
        }
        if ((name !== '' && name !== null && name.length > 6) || (mobile !== '' && mobile !== null && mobile.length >= 10)) {
            dispatch({
                type: globalAddressActions.ADDRESS_DETAILS_START,
                url: 'addressBook',
                filter: {
                    where: filter,
                    order: sortBy + ' ' + sortOrder
                }
            });
            handleOpen();
        }
    }

    const customObject = (details, id) => {
        let a = details && details.filter(function (el) { return el.id === id });
        if (a && a?.length !== 0) {
            return a[0];
        }
        return [];
    }

    const selectAddress = (data) => {
        if (data?.stateId) {
            changeStateApi(data?.stateId);
        }

        if (data?.pincodeId) {
            dispatch({
                type: addressActions.AREA_DETAILS_START, url: 'areas', filter: {
                    where: { ["and"]: [{ pincodeId: data?.pincodeId }] }
                }
            });
        }
        setName(data?.businessName ? data?.businessName : (data?.contactName ? data?.contactName : ''));
        setMobile(data?.mobile || '');
        setEmail(data?.email || '');
        setGabId(data?.id || '');
        setAreaId(data?.areaId || '');
        setAddress1(data?.address1 ? data?.address1 : '');
        setPincodeId(data?.pincodeId ? data?.pincodeId : '');
        setCityId(data?.cityId ? data?.cityId : '');
        setStateId(data?.stateId ? data?.stateId : '');
        setCountryId(data?.countryId ? data?.countryId : '');
        setCurrencyId(data?.country?.currencyId || '');
        setContactName(data?.contactName || '');
        setYounoteID(data?.businessId ? data?.businessId : '');
        setYounoteSerial(data?.business?.serialNo || '');
        if (data?.businessId) {
            setInAppStatus('REQUEST SENT');
        } else {
            setInAppStatus('---');
        }
        if (data?.taxTypeId) {
            setTaxTypeId(data?.taxTypeId || '');
            let a = taxType && taxType?.filter((el) => el.id === data?.taxTypeId);
            if (a && a.length > 0) {
                if (a[0]?.partyGstId) {
                    setGstCodeId(a[0]?.partyGstId);
                }
            }
        }
        setGstin(data?.gstNumber || '');
        handleClose();
    }

    useEffect(() => {
        if ((prevAddressSearchAll !== undefined && addressSearchAll && addressSearchAll.length > 4 && prevAddressSearchAll !== addressSearchAll)) {
            if (timeoutRef.current !== null) {
                clearTimeout(timeoutRef.current);
            }
            timeoutRef.current = setTimeout(() => {
                timeoutRef.current = null;
                let filter = { ["and"]: [{ isGloballyVisible: true }] };
                let or = { ["or"]: [] };
                or['or'].push({ businessName: { like: addressSearchAll.trim() + '%' } });
                or['or'].push({ contactName: { like: addressSearchAll.trim() + '%' } });
                or['or'].push({ mobile: { like: addressSearchAll.trim() + '%' } });
                or['or'].push({ email: { like: addressSearchAll.trim() + '%' } });
                filter['and'].push(or);
                dispatch({
                    type: globalAddressActions.ADDRESS_DETAILS_START,
                    url: 'addressBook',
                    filter: {
                        where: filter,
                        order: sortBy + ' ' + sortOrder
                    }
                });
            }, 500);
        }
    }, [addressSearchAll]);

    const handleBusinessType = (value) => {
        setBusinessType(value);
        if (value === 'INDIVIDUAL') {
            setClassification("OTHER");
        } else {
            setClassification('');
        }
    }

    const handlePartyGstDetails = () => {
        let result = partyGstdetails;
        if (taxTypeId !== '' && taxType && taxType.length > 0) {
            let a = taxType && taxType?.filter((el) => el.id === taxTypeId);
            if (a && a.length > 0 && a[0]?.taxCode === 'SPEZ') {
                result = partyGstdetails.filter((el) => { return el.isSEZ })
            }
        }
        return result;
    }

    const classes = customStyles();
    return (
        <React.Fragment>
            <MainHeader {...props}
                cls={'newImg'}
                img={SalesIcon}
                title={'Sales'}
                links={[{ 'label': 'Sales', 'link': '/sales' },
                { 'label': 'All Customers', 'link': '/sales/sales-management/all-customers' },
                { 'label': 'Customer Details', 'link': '' }]}
            />
            <div className={clsx(classes.margin40, classes.listTableMargin, classes.listTableSticky, classes.scrollBorder)}>
                <div id="containerDiv" className={clsx(classes.stickyContainer)}>
                    <CustomAccordion
                        title={'Add Customer'}
                        top={"0"}
                        topVisible={"50px"}
                        zIndex={9}
                        showDetails={false}
                        index={0}
                        ref={childRef}
                        component={
                            <>
                                <Box
                                    className={clsx(classes.removeUnderline)}
                                    component="form"
                                    autoComplete='off'

                                    onSubmit={(e) => handleSubmit(e)}>
                                    <Row>
                                        <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} className={classes.textAlignCenter}>
                                            {
                                                commonError && <CustomAlert error={commonError} customClass={clsx(classes.uploadError)} />
                                            }
                                        </Col>
                                        <Col xxl={4} xl={4} lg={4} md={4} sm={4} xs={4}>
                                            <Typography variant={'h6'} className={clsx(classes.typographyHeader, classes.bold)}
                                            >General</Typography>
                                        </Col>
                                        <Col xxl={20} xl={20} lg={20} md={20} sm={20} xs={20} className={classes.textAlignRight}>
                                            <Button
                                                tabIndex={-1}
                                                type='submit'
                                                color='primary'
                                                variant="contained"
                                                id={idNamingConversion('submit', 'customerProfile', 'Button')}
                                                className={clsx(classes.modalBtn, { [classes.loading]: createLoader })}>
                                                Save
                                            </Button>
                                        </Col>
                                    </Row>
                                    <Row gutter={50}>
                                        <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                            <AutoCompleteComponent
                                                name={["Business Type ", <span key="Business Type" className={classes.colorRedRequired}> *</span>]}
                                                heads={[{ 'key': 'label', 'name': 'Name' }]}
                                                details={customerTypeList}
                                                id={idNamingConversion('Business Type', 'customerProfile', 'DropDown')}
                                                parentValue={customObject(customerTypeList, businessType)}
                                                onChange={(data) => { setErroBusinessType(false); handleBusinessType(data.id) }}
                                                position={"bottom"}
                                                customClasses={classes.margin20t}
                                                parentError={errorBusinessType}
                                            />
                                        </Col>
                                        <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                            <TextField autoComplete='one-time-code'
                                                label={["Customer Name ", <span key="Customer Name" className={classes.colorRedRequired}> *</span>]}
                                                fullWidth
                                                className={classes.margin20t}
                                                error={errorName && true}
                                                helperText={errorName}
                                                value={name}
                                                name={'customer_name'}
                                                variant={'standard'}
                                                id={idNamingConversion('Customer Name', 'customerProfile', 'TextField')}
                                                InputProps={{
                                                    classes: {
                                                        input: classes.textFieldColor
                                                    },
                                                    endAdornment: (
                                                        <InputAdornment position="end" onClick={() => addressSearch()}>
                                                            <IconButton
                                                                tabIndex={-1}
                                                            >
                                                                <Search />
                                                            </IconButton>
                                                        </InputAdornment>
                                                    ),
                                                    form: {
                                                        autocomplete: 'off',
                                                    },
                                                }}
                                                InputLabelProps={{
                                                    className: classes.textFieldLableColorCustom
                                                }}
                                                onChange={(e) => setName(e.target.value)}
                                            />
                                        </Col>
                                        <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                            <FormControlLabel
                                                classes={{
                                                    label: clsx(classes.fonSize13, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink') // Pass your override css here
                                                }}
                                                id={idNamingConversion('Hold', 'customerProfile', 'Radio')}
                                                control={<Switch size='small'
                                                    className={clsx(classes.customSwitch)}
                                                    onChange={(e) => setIsHold(!isHold)}
                                                    checked={isHold}
                                                />}
                                                label="Hold"
                                                labelPlacement="top"
                                                className={clsx(classes.marginLeft0, classes.flexStart, classes.margin20t)}
                                            />
                                        </Col>
                                        <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                            <FormControlLabel
                                                classes={{
                                                    label: clsx(classes.fonSize13, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink') // Pass your override css here
                                                }}
                                                id={idNamingConversion('Price Include Tax', 'customerProfile', 'Radio')}
                                                control={<Switch size='small'
                                                    className={clsx(classes.customSwitch)}
                                                    onChange={(e) => setPriceIncludesTax(!priceIncludesTax)}
                                                    checked={priceIncludesTax}
                                                />}
                                                label="Price Includes Tax"
                                                labelPlacement="top"
                                                className={clsx(classes.marginLeft0, classes.flexStart, classes.margin20t)}
                                            />
                                        </Col>
                                        <Col xxl={4} xl={4} lg={6} md={8} sm={12} xs={24}>
                                            <AutoCompleteComponent
                                                name={["Sales Rep Id "]}
                                                heads={[{ 'key': 'name', 'name': 'Name' }]}
                                                details={getTeamData && getTeamData?.filter(el => el.status === 'ACTIVE')}
                                                parentValue={customObject(getTeamData && getTeamData?.filter(el => el.status === 'ACTIVE'), salesRepId)}
                                                onChange={(data) => setSalesRepId(data.id)}
                                                id={idNamingConversion('Sales Rep Id', 'customerProfile', 'DropDown')}
                                                onChangeText={(value) => {
                                                    if (value === '') {
                                                        setSalesRepId('')
                                                    }
                                                }}
                                                position={"bottom"}
                                                customClasses={classes.margin20t}
                                            />
                                        </Col>
                                        <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                            <TextField autoComplete='one-time-code'
                                                label={["Mobile Number ", <span key="Mobile Number" className={classes.colorRedRequired}> *</span>]}
                                                fullWidth
                                                //type='number'
                                                error={errorMobile && true}
                                                helperText={errorMobile}
                                                value={mobile}
                                                variant={'standard'}
                                                id={idNamingConversion('Mobile Number', 'customerProfile', 'TextField')}
                                                className={clsx(classes.margin20t)}
                                                onWheel={(e) => e.target.blur()}
                                                InputProps={{
                                                    classes: {
                                                        input: classes.textFieldColor,
                                                    },
                                                    endAdornment: (
                                                        <InputAdornment position="end" onClick={() => addressSearch()}>
                                                            <IconButton tabIndex={-1}>
                                                                <Search />
                                                            </IconButton>
                                                        </InputAdornment>
                                                    )
                                                }}
                                                InputLabelProps={{
                                                    className: classes.textFieldLableColorCustom
                                                }}
                                                //  onKeyDown={(e) => handleKeyDown(e)}
                                                onChange={(e) => setMobile(e.target.value)}
                                            />
                                        </Col>
                                        <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                            <TextField autoComplete='one-time-code'
                                                label='Email'
                                                fullWidth
                                                value={email}
                                                error={errorEmail && true}
                                                helperText={errorEmail}
                                                variant={'standard'}
                                                id={idNamingConversion('Email', 'customerProfile', 'TextField')}
                                                className={clsx(classes.margin20t)}
                                                InputProps={{
                                                    classes: {
                                                        input: classes.textFieldColor,
                                                    }
                                                }}
                                                InputLabelProps={{
                                                    className: classes.textFieldLableColorCustom,
                                                }}
                                                onChange={(e) => setEmail(e.target.value)}
                                            />
                                        </Col>
                                        <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                            <AutoCompleteComponent
                                                name={["Classification "]}
                                                heads={[{ 'key': 'label', 'name': 'Name' }]}
                                                details={classificationList}
                                                parentValue={customObject(classificationList, classification)}
                                                onChange={(data) => setClassification(data.id)}
                                                position={"bottom"}
                                                id={idNamingConversion('Classification', 'customerProfile', 'DropDown')}
                                                parentError={errorClassification}
                                                onChangeText={(value) => {
                                                    if (value === '') {
                                                        setClassification('')
                                                    }
                                                }}
                                                customClasses={classes.margin20t}
                                            />
                                        </Col>
                                        <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                            <AutoCompleteComponent
                                                name={["Preferred Language ", <span key="Preferred Language" className={classes.colorRedRequired}> *</span>]}
                                                heads={[{ 'key': 'name', 'name': 'Name' }]}
                                                details={languageDetails}
                                                parentValue={customObject(languageDetails, languageId)}
                                                onChange={(data) => setLanguageId(data.id)}
                                                position={"bottom"}
                                                id={idNamingConversion('Preferred Language', 'customerProfile', 'DropDown')}
                                                parentError={errorLanguage}
                                                customClasses={classes.margin20t}
                                            />
                                        </Col>
                                        <Col xxl={4} xl={4} lg={6} md={8} sm={12} xs={24}>
                                            <AutoCompleteComponent
                                                name={["Group "]}
                                                heads={[{ 'key': 'name', 'name': 'Name' },
                                                { 'key': 'description', 'name': 'Description' }]}
                                                details={customerGroupdetails}
                                                parentValue={customObject(customerGroupdetails, groupId)}
                                                onChange={(data) => setGroupId(data.id)}
                                                id={idNamingConversion('Group', 'customerProfile', 'DropDown')}
                                                onChangeText={(value) => {
                                                    if (value === '') {
                                                        setGroupId('')
                                                    }
                                                }}
                                                position={"bottom"}
                                                customClasses={classes.margin20t}
                                            />
                                        </Col>
                                        <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                            <Typography variant={'h6'} className={clsx(classes.margin35t, classes.typographyHeader, classes.bold)}>
                                                GST Details</Typography>
                                        </Col>
                                        <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                            <AutoCompleteComponent
                                                name={["GST Type ", <span key="GST Type" className={classes.colorRedRequired}> *</span>]}
                                                heads={[{ 'key': 'name', 'name': 'Name' },
                                                { 'key': 'taxCode', 'name': 'Code' }]}
                                                details={gstTypeList}
                                                parentValue={customObject(gstTypeList, taxTypeId)}
                                                id={idNamingConversion('GST Type', 'customerProfile', 'DropDown')}
                                                onChange={(data) => {
                                                    setTaxTypeId(data.id);
                                                    setGstCodeId(data?.partyGstId || '');
                                                }}
                                                parentError={errorGstType}
                                                position={"bottom"}
                                                customClasses={clsx(classes.margin20t, classes.dropDownPointer)}
                                            />
                                        </Col>
                                        <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                            <AutoCompleteComponent
                                                name={["Party GST Code "]}
                                                heads={[{ 'key': 'code', 'name': 'Party GST Code' },
                                                { 'key': 'description', 'name': 'Description' }]}
                                                details={handlePartyGstDetails()}
                                                id={idNamingConversion('Party GST Code', 'customerProfile', 'DropDown')}
                                                parentValue={customObject(handlePartyGstDetails(), gstCodeId)}
                                                onChange={(data) => setGstCodeId(data.id)}
                                                parentError={errorGstCode}
                                                position={"bottom"}
                                                customClasses={classes.margin20t}
                                            />
                                        </Col>
                                        <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                            <TextField autoComplete='one-time-code'
                                                label='GST Number (GSTIN)'
                                                fullWidth
                                                error={errorGstIn && true}
                                                helperText={errorGstIn}
                                                id={idNamingConversion('GST Number', 'customerProfile', 'TextField')}
                                                value={gstin}
                                                variant={'standard'}
                                                className={clsx(classes.margin20t)}
                                                InputProps={{
                                                    classes: {
                                                        input: classes.textFieldColor,
                                                    }
                                                }}
                                                InputLabelProps={{
                                                    className: classes.textFieldLableColorCustom,
                                                }}
                                                onChange={(e) => setGstin(e.target.value)}
                                            />
                                        </Col>
                                        <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                            <FormControl
                                                tabIndex={-1}
                                                className={clsx(classes.margin20t, classes.dropDownPointer, classes.customRadioButton, classes.customIdentityRadioButton)}
                                                variant={'standard'}
                                                fullWidth>
                                                <FormLabel className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Identity Type</FormLabel>
                                                <RadioGroup row
                                                    defaultValue={"PAN"}
                                                    aria-labelledby="demo-customized-radios"
                                                    name="identityType"
                                                    value={identityType || "PAN"}
                                                    onChange={(e) => setIdentityType(e.target.value)}>
                                                    <FormControlLabel value={"PAN"} control={<Radio
                                                        checkedIcon={<UnSelectedIcon />}
                                                        icon={<SelectedIcon />}
                                                    />} label="PAN" />
                                                    <FormControlLabel value={"TAN"} control={<Radio
                                                        checkedIcon={<UnSelectedIcon />}
                                                        icon={<SelectedIcon />}
                                                    />} label="TAN" />
                                                    <FormControlLabel value={"CIN"} control={<Radio
                                                        checkedIcon={<UnSelectedIcon />}
                                                        icon={<SelectedIcon />}
                                                    />} label="CIN" />
                                                    <FormControlLabel value={'LIC'} control={<Radio
                                                        checkedIcon={<UnSelectedIcon />}
                                                        icon={<SelectedIcon />}
                                                    />} label="License Number" />
                                                </RadioGroup>
                                            </FormControl>
                                        </Col>
                                        <Col xxl={4} xl={4} lg={6} md={8} sm={12} xs={24}>
                                            <TextField autoComplete='one-time-code'
                                                label={`${identityType || "PAN"} Number`}
                                                fullWidth
                                                id={idNamingConversion("PAN Number", 'customerProfile', 'TextField')}
                                                value={pan}
                                                variant={'standard'}
                                                className={clsx(classes.margin20t)}
                                                InputProps={{
                                                    classes: {
                                                        input: classes.textFieldColor,
                                                    }
                                                }}
                                                InputLabelProps={{
                                                    className: classes.textFieldLableColorCustom,
                                                }}
                                                onChange={(e) => setPan(e.target.value)}
                                            />
                                        </Col>
                                        <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                            <Typography variant={'h6'} className={clsx(classes.typographyHeaderToolTip, classes.margin35t, classes.typographyHeader, classes.bold)}>
                                                <span>Address</span>
                                                <Tooltip
                                                    classes={{ popper: clsx(classes.customToolTip, classes.customToolTipWidth) }}
                                                    title={'Billing Address'} arrow placement="top" className={clsx(classes.tooltip)}>
                                                    <IconButton>
                                                        <Image src={infoMarkIcon}
                                                            preview={false} />
                                                    </IconButton>
                                                </Tooltip>
                                            </Typography>
                                        </Col>
                                        <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                            <AutoCompleteComponent
                                                name={["State/Province ", <span key={"State/Province"} className={classes.colorRedRequired}> *</span>]}
                                                heads={[{ 'key': 'name', 'name': 'State Name' },
                                                { 'key': 'country', 'name': 'Country Name', 'relation': 'name' }]}
                                                details={stateDetails}
                                                parentValue={customObject(stateDetails, stateId)}
                                                onChange={(data) => changeState(data.id)}
                                                position={"top"}
                                                id={idNamingConversion('State', 'customerProfile', 'DropDown')}
                                                customClasses={classes.margin20t}
                                                parentError={errorState}
                                                infoMark={'The value selected in this field defaults from your Business address. Please select the correct State address for the Party record.'}
                                            />
                                        </Col>
                                        <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                            <AutoCompleteComponent
                                                name={["Pincode ", <span key={"Pincode"} className={classes.colorRedRequired}> *</span>]}
                                                heads={[{ 'key': 'code', 'name': 'Pincode' },
                                                { 'key': 'city', 'name': 'City', 'relation': 'name' }]}
                                                details={pincodeDetails}
                                                id={idNamingConversion('Pincode', 'customerProfile', 'DropDown')}
                                                parentValue={customObject(pincodeDetails, pincodeId)}
                                                onChange={(data) => changePincode(data.id)}
                                                position={"top"}
                                                customClasses={classes.margin20t}
                                                parentError={errorPincode}
                                            />
                                        </Col>
                                        <Col xxl={14} xl={14} lg={14} md={14} sm={14} xs={14}></Col>
                                        <Col xxl={10} xl={10} lg={24} md={24} sm={24} xs={24}>
                                            <Row gutter={50}>
                                                <Col xxl={12} xl={12} lg={6} md={8} sm={12} xs={24}>
                                                    <TextField autoComplete='one-time-code'
                                                        label=''
                                                        value={address1}
                                                        placeholder='Door/Building Number,&#10;Building Name&#10;Street Address&#10;Locality'
                                                        variant={'outlined'}
                                                        className={clsx(classes.margin20t, classes.customDescription)}
                                                        fullWidth
                                                        multiline
                                                        id={idNamingConversion('address', 'customerProfile', 'TextField')}
                                                        name={"address"}
                                                        rows={6}
                                                        InputProps={{
                                                            classes: {
                                                                input: classes.textFieldColor,
                                                            },
                                                            style: { height: 170 },
                                                        }}
                                                        InputLabelProps={{
                                                            className: classes.textFieldLableColor,
                                                        }}
                                                        onChange={(e) => setAddress1(e.target.value)}
                                                    />
                                                </Col>
                                                <Col xxl={12} xl={12} lg={6} md={8} sm={12} xs={24}>
                                                    <AutoCompleteComponent
                                                        name={["Area"]}
                                                        heads={[{ 'key': 'name', 'name': 'Area Name' },
                                                        { 'key': 'pincode', 'name': 'Pincode', 'relation': 'code' },
                                                        { 'key': 'city', 'name': 'City', 'relation': 'name' },
                                                        { 'key': 'state', 'name': 'State', 'relation': 'shortName' }]}
                                                        details={areaDetails}
                                                        parentValue={customObject(areaDetails, areaId)}
                                                        onChange={(data) => { changeArea(data.id) }}
                                                        position={"top"}
                                                        id={idNamingConversion('Area', 'customerProfile', 'DropDown')}
                                                        customClasses={classes.margin20t}
                                                        customLink={'/admin/address/area'}
                                                        linkText={'Go to Area'}
                                                        infoMark={'Select the local postal area from the list or Goto Area master to create a new record for the missing area info. The field is optional and will take blank values.'}
                                                    />
                                                    <AutoCompleteComponent
                                                        name={["Dist/City/Town"]}
                                                        heads={[{ 'key': 'name', 'name': 'Name' },
                                                        { 'key': 'state', 'name': 'State Name', 'relation': 'shortName' }]}
                                                        details={cityDetails}
                                                        id={idNamingConversion('City', 'customerProfile', 'DropDown')}

                                                        parentValue={customObject(cityDetails, cityId)}
                                                        onChange={(data) => changeCity(data.id)}
                                                        position={"top"}
                                                        customClasses={clsx(classes.margin20t)}
                                                    />
                                                    <AutoCompleteComponent
                                                        name={["Country"]}
                                                        heads={[{ 'key': 'name', 'name': 'Country Name' }]}
                                                        details={countryDetails}
                                                        id={idNamingConversion('Country', 'customerProfile', 'DropDown')}
                                                        parentValue={customObject(countryDetails, countryId)}
                                                        onChange={(data) => handleChangeCountry(data.id)}
                                                        position={"top"}
                                                        customClasses={clsx(classes.margin20t)}
                                                    />
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col xxl={14} xl={14} lg={14} md={14} sm={24} xs={24} ></Col>
                                        <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                            <Typography variant={'h6'} className={clsx(classes.margin35t, classes.typographyHeader, classes.bold)}>
                                                Other Contact Details</Typography>
                                        </Col>
                                        <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                            <TextField autoComplete='one-time-code'
                                                fullWidth
                                                error={errorContactForm && true}
                                                helperText={errorContactForm}
                                                label='Contact Name'
                                                value={contactName}
                                                variant={'standard'}
                                                id={idNamingConversion('Contact Name', 'customerProfile', 'TextField')}
                                                className={clsx(classes.margin20t)}
                                                InputProps={{
                                                    classes: {
                                                        input: classes.textFieldColor,
                                                    }
                                                }}
                                                InputLabelProps={{
                                                    className: classes.textFieldLableColorCustom,
                                                }}
                                                onChange={(e) => setContactName(e.target.value)}
                                            />
                                        </Col>
                                        <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                            <TextField autoComplete='one-time-code'
                                                label='Alternate Name (Optional)'
                                                error={erroremptyAlternateName && true}
                                                helperText={erroremptyAlternateName}
                                                fullWidth
                                                value={tradingName}
                                                variant={'standard'}
                                                id={idNamingConversion('Alternate Name', 'customerProfile', 'TextField')}
                                                className={clsx(classes.margin20t)}
                                                InputProps={{
                                                    classes: {
                                                        input: classes.textFieldColor,
                                                    }
                                                }}
                                                InputLabelProps={{
                                                    className: classes.textFieldLableColorCustom,
                                                }}
                                                onChange={(e) => setTradingName(e.target.value)}
                                            />
                                        </Col>
                                        <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                            <TextField autoComplete='one-time-code'
                                                label='Alternate Phone'
                                                value={alternateMobile}
                                                type='number'
                                                // error={erroremptyAlternateNumber && true}
                                                // helperText={erroremptyAlternateNumber}
                                                fullWidth
                                                id={idNamingConversion('Alternate Phone', 'customerProfile', 'TextField')}
                                                variant={'standard'}
                                                className={clsx(classes.margin20t)}
                                                onWheel={(e) => e.target.blur()}
                                                InputProps={{
                                                    classes: {
                                                        input: classes.textFieldColor,
                                                    }
                                                }}
                                                InputLabelProps={{
                                                    className: classes.textFieldLableColorCustom,
                                                }}
                                                onChange={(e) => setAlternateMobile(e.target.value)}
                                            />
                                        </Col>
                                        <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                            <Typography variant={'h6'} className={clsx(classes.margin35t, classes.typographyHeader, classes.bold)}>
                                                Payment Info</Typography>
                                        </Col>
                                        <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                            <AutoCompleteComponent
                                                name={["Method of payment (MOP)"]}
                                                heads={[{ 'key': 'method', 'name': 'Method' },
                                                { 'key': 'description', 'name': 'Description' }]}
                                                details={mopDetails}
                                                id={idNamingConversion('Method of payment', 'customerProfile', 'DropDown')}
                                                parentValue={customObject(mopDetails, mopId)}
                                                onChange={(data) => setMopId(data.id)}
                                                position={"top"}
                                                onChangeText={(value) => {
                                                    if (value === '') {
                                                        setMopId('')
                                                    }
                                                }}
                                                customClasses={classes.margin20t}
                                            />
                                        </Col>
                                        <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                            <AutoCompleteComponent
                                                name={["Currency ", <span key={"Currency"} className={classes.colorRedRequired}> *</span>]}
                                                heads={[{ 'key': 'name', 'name': 'Currency Name' },
                                                { 'key': 'shortName', 'name': 'Currency Short Form' }]}
                                                details={currencyDetails}
                                                id={idNamingConversion('Currency', 'customerProfile', 'DropDown')}
                                                parentValue={customObject(currencyDetails, currencyId)}
                                                onChange={(data) => setCurrencyId(data.id)}
                                                parentError={errorCurrency}
                                                position={"top"}
                                                customClasses={classes.margin20t}
                                            />
                                        </Col>
                                        <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                            <Typography variant={'h6'} className={clsx(classes.margin35t, classes.typographyHeader, classes.bold)}>
                                                Younote Info</Typography>
                                        </Col>
                                        <Col xxl={5} xl={5} lg={6} md={8} sm={8} xs={24} className={classes.margin20t}>
                                            <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Younote ID</Typography>
                                            <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{younoteID ? younoteSerial : '---'}</Typography>
                                        </Col>
                                        <Col xxl={5} xl={5} lg={6} md={8} sm={8} xs={24} className={classes.margin20t}>
                                            <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>In-App Status</Typography>
                                            <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{inAppStatus ? capitalizeFirstLetter(inAppStatus) : 'No'}</Typography>
                                        </Col>
                                        <Col xxl={5} xl={5} lg={6} md={8} sm={8} xs={24} className={clsx(classes.margin20t)}>
                                            <FormControlLabel
                                                classes={{
                                                    label: clsx(classes.fonSize13, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink') // Pass your override css here
                                                }}
                                                id={idNamingConversion('In-AppTransactions', 'customerProfile', 'Radio')}
                                                control={<Switch className={clsx(classes.customSwitch)} size='small' />}
                                                label="In-AppTransactions"
                                                checked={false}
                                                labelPlacement="top"
                                                className={clsx(classes.marginLeft0, classes.flexStart)}
                                            />
                                        </Col>
                                        <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                            <Typography variant={'h6'} className={clsx(classes.margin35t, classes.typographyHeader, classes.bold)}>
                                                Other Taxes</Typography>
                                        </Col>
                                        <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                            <AutoCompleteComponent
                                                name={["Cash Discount"]}
                                                heads={[{ 'key': 'code', 'name': 'Code' }]}
                                                details={cashDiscountDetails || []}
                                                id={idNamingConversion('Cash Discount', 'customerProfile', 'DropDown')}
                                                parentValue={customObject(cashDiscountDetails || [], cashDiscountId)}
                                                onChange={(data) => setCashDiscountId(data.id)}
                                                position={"top"}
                                                customClasses={classes.margin20t}
                                            />
                                        </Col>
                                        <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                            <AutoCompleteComponent
                                                name={["Tax Code "]}
                                                heads={[{ 'key': 'code', 'name': 'Code' }]}
                                                details={taxCodedetails}
                                                id={idNamingConversion('Tax Code', 'customerProfile', 'DropDown')}
                                                parentValue={customObject(taxCodedetails, taxCodeId)}
                                                onChange={(data) => setTaxCodeId(data.id)}
                                                position={"top"}
                                                customClasses={classes.margin20t}
                                            />
                                        </Col>
                                        <Col xxl={5} xl={5} lg={6} md={8} sm={8} xs={24}>
                                            <FormControlLabel
                                                classes={{
                                                    label: clsx(classes.fonSize13, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink') // Pass your override css here
                                                }}
                                                id={idNamingConversion('TCS', 'customerProfile', 'Radio')}
                                                control={<Switch size='small'
                                                    className={clsx(classes.customSwitch)}
                                                    onChange={(e) => setTcs(!tcs)}
                                                    checked={tcs}
                                                />}
                                                label="TCS"
                                                labelPlacement="top"
                                                className={clsx(classes.marginLeft0, classes.flexStart, classes.margin20t)}

                                            />
                                        </Col>
                                        <Col xxl={5} xl={5} lg={6} md={8} sm={8} xs={24}>
                                            <FormControlLabel
                                                classes={{
                                                    label: clsx(classes.fonSize13, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink') // Pass your override css here
                                                }}
                                                id={idNamingConversion('TDS', 'customerProfile', 'Radio')}
                                                control={<Switch size='small'
                                                    className={clsx(classes.customSwitch)}
                                                    onChange={(e) => setTds(!tds)}
                                                    checked={tds}
                                                />}
                                                label="TDS"
                                                labelPlacement="top"
                                                className={clsx(classes.marginLeft0, classes.flexStart, classes.margin20t)}
                                            />
                                        </Col>
                                        {
                                            tcs && <Col xxl={4} xl={4} lg={6} md={8} sm={12} xs={24}>
                                                <AutoCompleteComponent
                                                    name={["TCS "]}
                                                    heads={[{ 'key': 'name', 'name': 'Name' }]}
                                                    details={(otherTaxesdetails || []).filter(el => el.taxType === 'TCS')}
                                                    id={idNamingConversion('TCS', 'customerProfile', 'DropDown')}
                                                    parentValue={customObject((otherTaxesdetails || []).filter(el => el.taxType === 'TCS'), tcsId)}
                                                    onChange={(data) => setTcsId(data.id)}
                                                    position={"top"}
                                                    customClasses={classes.margin20t}
                                                    parentError={errorTcs}
                                                />
                                            </Col>
                                        }

                                    </Row>
                                </Box>
                            </>
                        }
                    />
                    {/* <CustomAccordion
                        title={"Sales Price Details"}
                        top={"49"}
                        topVisible={"150px"}
                        zIndex={7}
                        showDetails={false}
                        index={1}
                        ref={childRef}
                        component={""}
                    />
                    <CustomAccordion
                        title={"Customer Products"}
                        top={"116"}
                        topVisible={"250px"}
                        zIndex={5}
                        showDetails={false}
                        index={2}
                        ref={childRef}
                        component={""}
                        lastContent={true}
                    /> */}
                </div>
            </div>
            <PrimaryDrawer
                anchor={'right'}
                open={visible}
                variant={'temporary'}
                handleClose={() => handleClose()}
                width={'695px'}
                title={'Global Address Book'}
                className={clsx(classes.closeBackGround, classes.width100P)}
                component={
                    <PrimaryCard
                        customClass={classes.addressTable}
                        component={
                            <>
                                <Row align="middle" className={classes.marginBottom20}>
                                    <Col xxl={8} xl={8} lg={8} md={8} sm={24} xs={24}>
                                        <div className={clsx(classes.searchAnimation, { [classes.iconAnimation]: iconAnimation })}>
                                            <TextField autoComplete='one-time-code'
                                                placeholder='Search'
                                                type='search'
                                                fullWidth
                                                onChange={(e) => setAddressSearchAll(e.target.value)}
                                                className={classes.comInput}
                                                variant={'standard'}
                                                onFocus={() => setIconAnimation(true)}
                                                onBlur={() => setIconAnimation(false)}
                                                id={idNamingConversion('Address Book Search', 'customerProfile', 'TextField')}
                                            />
                                            <Image
                                                src={SearchIcon}
                                                preview={false}
                                            />
                                        </div>
                                    </Col>
                                </Row>
                                <AddressTable selectAddress={(data) => selectAddress(data)} details={addressDetails} loader={addressLoader} sortOrder={sortOrder} sortBy={sortBy} />
                            </>
                        }
                    />
                }
            />
            <QuickLinks menus={menus} factBox={true} component={"All Customers"} onParentFunction={() => childRef?.current?.handleAdjustHeight()}> </QuickLinks>
        </React.Fragment>
    )
}
export default CustomerCreate